// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_container__SjpRI {
  display: grid;
  grid-template-columns: repeat(2, 50%);
  max-width: 100vw;
}
@media only screen and (max-width: 62.5em) {
  .Login_container__SjpRI {
    display: flex;
    flex-direction: column;
    gap: 3rem;
    align-items: center;
    justify-content: flex-start;
    padding: 6rem;
    background-color: var(--color-light-blue-3);
    min-height: 100vh;
  }
}
@media only screen and (max-width: 62.5em) {
  .Login_container__SjpRI {
    padding: 3rem;
  }
}

.Login_leftside__FS9NJ {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--color-white);
  padding: 3rem 10rem 0 10rem;
  min-height: 100vh;
}

.Login_rightside__nhkW7 {
  background-color: var(--color-light-blue-3);
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.Login_adminImage__-ASkF {
  height: 44rem;
  position: relative;
  left: -12%;
}
@media only screen and (max-width: 62.5em) {
  .Login_adminImage__-ASkF {
    left: 0;
    height: 30rem;
    top: 8rem;
  }
}
@media only screen and (max-width: 31.25em) {
  .Login_adminImage__-ASkF {
    left: 0;
    height: 17rem;
    top: 6rem;
  }
}

.Login_logo__VaYjm {
  height: 3.8rem;
  margin-bottom: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Login_logo__VaYjm {
    position: relative;
    top: 8rem;
  }
}
@media only screen and (max-width: 31.25em) {
  .Login_logo__VaYjm {
    position: relative;
    top: 6rem;
  }
}

.Login_magic__cS9kM {
  font-size: var(--default-font-h3);
  font-weight: 700;
  text-align: center;
  line-height: 3.8rem;
  margin-top: 5rem;
}
@media only screen and (max-width: 62.5em) {
  .Login_magic__cS9kM {
    font-size: var(--default-font-subtitle);
    line-height: 3rem;
    margin-top: 0;
  }
}
@media only screen and (max-width: 31.25em) {
  .Login_magic__cS9kM {
    font-size: var(--default-font-size);
    line-height: 2.7rem;
    margin-top: 0;
    margin-bottom: 2rem;
  }
}

.Login_formCard__KS4mp {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10rem 7rem;
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  border-radius: 0.8rem;
}
@media only screen and (max-width: 31.25em) {
  .Login_formCard__KS4mp {
    padding: 5rem 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Login/Login.module.scss"],"names":[],"mappings":"AAGA;EACC,aAAA;EACA,qCAAA;EACA,gBAAA;AAFD;AAIC;EALD;IAME,aAAA;IACA,sBAAA;IACA,SAAA;IACA,mBAAA;IACA,2BAAA;IACA,aAAA;IACA,2CAAA;IACA,iBAAA;EADA;AACF;AAGC;EAhBD;IAiBE,aAAA;EAAA;AACF;;AAIA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,2BAAA;EACA,iBAAA;AADD;;AAIA;EACC,2CAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AADD;;AAIA;EACC,aAAA;EACA,kBAAA;EACA,UAAA;AADD;AAGC;EALD;IAME,OAAA;IACA,aAAA;IACA,SAAA;EAAA;AACF;AAEC;EAXD;IAYE,OAAA;IACA,aAAA;IACA,SAAA;EACA;AACF;;AAIA;EACC,cAAA;EACA,mBAAA;AADD;AAGC;EAJD;IAKE,kBAAA;IACA,SAAA;EAAA;AACF;AAEC;EATD;IAUE,kBAAA;IACA,SAAA;EACA;AACF;;AAEA;EACC,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AACD;AACC;EAPD;IAQE,uCAAA;IACA,iBAAA;IACA,aAAA;EAEA;AACF;AAAC;EAbD;IAcE,mCAAA;IACA,mBAAA;IACA,aAAA;IACA,mBAAA;EAGA;AACF;;AACA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,4CAAA;EACA,qBAAA;AAED;AAAC;EAVD;IAWE,kBAAA;EAGA;AACF","sourcesContent":["@import '../variables/breakpoints';\n\n//Styling the container\n.container {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(2, 50%);\n\tmax-width: 100vw;\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 3rem;\n\t\talign-items: center;\n\t\tjustify-content: flex-start;\n\t\tpadding: 6rem;\n\t\tbackground-color: var(--color-light-blue-3);\n\t\tmin-height: 100vh;\n\t}\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\tpadding: 3rem;\n\t}\n}\n\n// Styling the left side\n.leftside {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground-color: var(--color-white);\n\tpadding: 3rem 10rem 0 10rem;\n\tmin-height: 100vh;\n}\n\n.rightside {\n\tbackground-color: var(--color-light-blue-3);\n\tmin-height: 100vh;\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.adminImage {\n\theight: 44rem;\n\tposition: relative;\n\tleft: -12%;\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\tleft: 0;\n\t\theight: 30rem;\n\t\ttop: 8rem;\n\t}\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tleft: 0;\n\t\theight: 17rem;\n\t\ttop: 6rem;\n\t}\n\n}\n\n\n.logo {\n\theight: 3.8rem;\n\tmargin-bottom: 2rem;\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\tposition: relative;\n\t\ttop: 8rem;\n\t}\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tposition: relative;\n\t\ttop: 6rem;\n\t}\n}\n\n.magic {\n\tfont-size: var(--default-font-h3);\n\tfont-weight: 700;\n\ttext-align: center;\n\tline-height: 3.8rem;\n\tmargin-top: 5rem;\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\tfont-size: var(--default-font-subtitle);\n\t\tline-height: 3rem;\n\t\tmargin-top: 0;\n\t}\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tfont-size: var(--default-font-size);\n\t\tline-height: 2.7rem;\n\t\tmargin-top: 0;\n\t\tmargin-bottom: 2rem;\n\n\t}\n}\n\n.formCard {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 10rem 7rem;\n\tbackground-color: var(--color-white);\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\tborder-radius: 0.8rem;\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tpadding: 5rem 2rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Login_container__SjpRI`,
	"leftside": `Login_leftside__FS9NJ`,
	"rightside": `Login_rightside__nhkW7`,
	"adminImage": `Login_adminImage__-ASkF`,
	"logo": `Login_logo__VaYjm`,
	"magic": `Login_magic__cS9kM`,
	"formCard": `Login_formCard__KS4mp`
};
export default ___CSS_LOADER_EXPORT___;
